export class ObjectGroup {
    public id: string;
    public organization_id: string;
    public name: string;
    public deleted: boolean;
    public object_ids: string[];
}
